import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import OutreachForm, {OutreachFormProps} from "../../../pages/program/outreach/components/OutreachForm";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, OutreachFormProps {
}

type Props = OwnProps;

// @ts-ignore
const OutreachModal = NiceModal.create<Props>(({outreach, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <OutreachForm outreach={outreach}/>
        </SlideOver>
    )
})

export default OutreachModal;
